<template>
  <div class="z-10 flex items-center">
    <Menu as="div" class="relative flex-shrink-0">
      <div>
        <MenuButton v-slot="{ open }" class="flex p-1 text-sm text-black rounded-md bg-white/50 ring-offset-1 focus:outline-none dark:bg-black/50 dark:text-white sm:bg-transparent">
          <span class="sr-only">Open menu</span>
          <v-icon class="w-6 h-6" v-if="!open" name="hi-menu" />
          <v-icon class="w-6 h-6" v-if="open" name="io-close" />
          <!-- <UserProfilePhoto class="w-8 h-8" v-if="userData" :photo="user.photoURL" :firstName="userData.firstName" :lastName="userData.lastName" /> -->
          <!-- <template v-if="!userData">
            <v-icon name="fa-user-circle" class="w-8 h-8 overflow-hidden text-gray-300 border-gray-200" scale="1" />
          </template> -->
        </MenuButton>
      </div>
      <transition
        enter-active-class="transition duration-100 ease-out"
        enter-from-class="transform scale-95 opacity-0"
        enter-to-class="transform scale-100 opacity-100"
        leave-active-class="transition duration-75 ease-in"
        leave-from-class="transform scale-100 opacity-100"
        leave-to-class="transform scale-95 opacity-0"
      >
        <MenuItems class="absolute right-0 w-48 py-3 mt-2 text-left origin-top-right bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-zinc-900">
          <MenuItem v-if="userData" v-slot="{ active }">
            <router-link to="/" :class="[active ? 'bg-gray-100 dark:bg-gray-700' : '', 'block px-4 py-2 text-sm text-gray-700 dark:text-gray-400']">
              <v-icon name="hi-collection" class="mr-2 text-gray-500 dark:text-gray-400" scale="1" />
              Content Review
            </router-link>
          </MenuItem>
          <MenuItem v-if="userData" v-slot="{ active }">
            <router-link to="/content" :class="[active ? 'bg-gray-100 dark:bg-gray-700' : '', 'block px-4 py-2 text-sm text-gray-700 dark:text-gray-400']">
              <v-icon name="co-library-add" class="mr-2 text-gray-500 dark:text-gray-400" scale="1" />
              Library
            </router-link>
          </MenuItem>
          <MenuItem v-if="userData" v-slot="{ active }">
            <router-link to="/progress" :class="[active ? 'bg-gray-100 dark:bg-gray-700' : '', 'block px-4 py-2 text-sm text-gray-700 dark:text-gray-400']">
              <v-icon name="co-chart-line" class="mr-2 text-gray-500 dark:text-gray-400" scale="1" />
              Progress
            </router-link>
          </MenuItem>
          <MenuItem v-if="userData" v-slot="{ active }" class="pb-5 border-b">
            <router-link to="/upload" :class="[active ? 'bg-gray-100 dark:bg-gray-700' : '', 'block px-4 py-2 text-sm text-gray-700 dark:text-gray-400']">
              <v-icon name="hi-document-add" class="mr-2 text-gray-500 dark:text-gray-400" scale="1" />
              Upload File/Text
            </router-link>
          </MenuItem>
          <MenuItem v-if="userData" v-slot="{ active }" class="pt-5">
            <router-link to="/profile" :class="[active ? 'bg-gray-100 dark:bg-gray-700' : '', 'block px-4 py-2 text-sm text-gray-700 dark:text-gray-400']">
              <UserProfilePhoto class="w-5 h-5 mr-2" :photo="user.photoURL" :firstName="userData.firstName" :lastName="userData.lastName" />
              Profile & Settings
            </router-link>
          </MenuItem>
          <MenuItem v-slot="{ active }">
            <a href="#" @click="signInOut" :class="[active ? 'bg-gray-100 dark:bg-gray-700' : '', 'block px-4 py-2 text-sm text-gray-700 dark:text-gray-400']">
              <v-icon name="hi-logout" class="mr-2 text-gray-500 dark:text-gray-400" scale="1" />
              {{ user ? "Logout" : "Sign In" }}
            </a>
          </MenuItem>
        </MenuItems>
      </transition>
    </Menu>
  </div>
</template>

<script>
import { getAuth, signOut } from "firebase/auth";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { ref, watchEffect } from "vue";
import firebaseUser from "../../composables/userAuth";
import utilFunctions from "../../composables/util";
import { useRouter } from "vue-router";
import UserProfilePhoto from "./UserProfilePhoto.vue";

export default {
  components: {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    UserProfilePhoto,
  },
  setup() {
    const { user } = firebaseUser();
    const { getUser } = utilFunctions();

    const userData = ref(null);

    const router = useRouter();

    watchEffect(async () => {
      if (user.value) {
        userData.value = await getUser(user.value.uid);
      }
    });

    function signInOut() {
      const auth = getAuth();
      if (!auth.currentUser) {
        router.push("auth");
      } else {
        signOut(auth)
          .then(() => {
            router.push("auth");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }

    return {
      userData,
      user,
      signInOut,
    };
  },
};
</script>
